import type { FollowerAbility } from '../../../schemas/follower';

/**
 * Abilità **Guardia del Corpo** (manuale V1, rr. 1380-1383).
 *
 * Uno scudo umano: si frappone tra il PG e i pericoli, prendendo
 * conseguenze al posto suo.
 */
export const guardiaDelCorpo: FollowerAbility = {
  id: 'guardia-del-corpo',
  label: 'Guardia del Corpo',
  description:
    'È un vero e proprio scudo, solo fatto di ciccia invece che di legno: si frappone tra il suo protetto e qualsiasi pericolo, che si tratti di lame affilate, zanne feroci, denti aguzzi o magie mortali.',
  ranks: [
    {
      rank: 1,
      trigger: 'Quando una Guardia del Corpo ti *aiuta* a *sfidare il pericolo*',
      description:
        'Con un 7-9, il gregario subirà le conseguenze al posto tuo. Con 6-, sia tu che il gregario ve la vedrete brutta.',
    },
    {
      rank: 2,
      trigger: 'Quando una Guardia del Corpo ti *aiuta* mentre fai *taglia e spacca*',
      description:
        'Con un 7-9, subisce la risposta del nemico al posto tuo. Con un fallimento, siete entrambi nei guai!',
    },
    {
      rank: 3,
      trigger: 'Quando una Guardia del Corpo ti *difende* e ha ancora prese disponibili',
      description: 'Sia tu che il gregario prendete +1 Armatura.',
    },
  ],
};
